import { createContext, ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * The footer node of the enclosing ActivationScreen, when it exposes one.
 * Null outside of it (legacy flow, a step rendered on its own in a test).
 */
export const ActivationFooterContext = createContext<HTMLElement | null>(null);

/** Host node for ActivationFooter portals; it adds no box of its own. */
export const createActivationFooterNode = () => {
  const node = document.createElement('div');
  node.style.display = 'contents';
  node.dataset.activationFooterSlot = '';
  return node;
};

export const ActivationFooter = ({ children }: { children: ReactNode }) => {
  const footerEl = useContext(ActivationFooterContext);
  return footerEl ? createPortal(children, footerEl) : <>{children}</>;
};
